;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import { useMemo } from 'react';

import { checkColorContrast } from 'utils/colors';

export const useTextAutoContrast = (backgroundColor, minimumRatio = 4.5) => {
    const darkContrast = useMemo(
        () => checkColorContrast(backgroundColor, 'blue'),
        [backgroundColor]
    );

    const lightContrast = useMemo(
        () => checkColorContrast(backgroundColor, 'cream'),
        [backgroundColor]
    );

    if (lightContrast < minimumRatio) {
        return 'dark';
    }

    return lightContrast < darkContrast ? 'dark' : 'light';
};
